/* Light Armor — spec-table accordions (added 2026-08-29, rev 8/29b).
 *
 * The per-product description HTML carries one spec <table> whose group headings
 * ("Dimensions & Shipping", "Power & Electrical", ...) are <th colspan> rows inside
 * the table. This script folds that table at its heading rows into flat <details>
 * accordions — ALL collapsed by default — sitting under a small "Technical
 * Specifications" label at the FOOT of the description block (rev c), with the
 * Product Attachments fold directly beneath them. Products with no such table
 * (accessories, spare parts) are untouched.
 *
 * Also: the coating chips ("Trusted For Every Finish") fold into the Read-more
 * clamp instead of always showing; the old spec intro (heading + highlight tiles) is
 * removed after harvesting any fact the table lacks; the Tigren Product Attachments
 * block collapses behind a "(N PDFs)" row placed inside the accordion stack, so the
 * divider lines run continuously; and on desktop the buy column's tail (the review
 * rotator) is nudged down when the description column runs longer, so the two
 * columns finish together instead of leaving a hole.
 *
 * SEO note: nothing is removed from the DOM except the redundant spec intro (whose
 * facts are preserved as table rows); everything else just moves or folds.
 */
(function () {
  'use strict';
  if (window.__laSpecAccInit) return;
  window.__laSpecAccInit = true;

  function esc(s) { return String(s).replace(/[&<>]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' })[c]; }); }

  /* A spec table is one with at least two full-width <th> heading rows. */
  function isGroupRow(tr) {
    return tr.cells.length === 1 && tr.cells[0].tagName === 'TH' && tr.cells[0].getAttribute('colspan');
  }

  /* The headings lead with a pictograph (✎ ⚡ 🌡 🛡). Desktop shows them fine, but
     without the emoji variation selector some Android fonts draw the text-style
     glyph invisibly small or not at all — so split it out, force emoji presentation
     with U+FE0F, and give it an emoji font stack in CSS. */
  /* Older product tables (the ovens) were authored without that leading glyph, so
     they rendered iconless next to the booths. Fall back to the group name. */
  var ICONS = [
    [/dimension|shipping|size/i, '\u270e'],
    [/power|electric/i, '\u26a1'],
    [/airflow|filtration|filter/i, '\ud83d\udca8'],
    [/performance|control|temperature|heat/i, '\ud83c\udf21'],
    [/included|support|warranty|lighting/i, '\ud83d\udee1']
  ];
  function iconFor(text) {
    for (var i = 0; i < ICONS.length; i++) if (ICONS[i][0].test(text)) return ICONS[i][1];
    return '';
  }
  function summaryHTML(title) {
    var m = /^([^\w\s]+)\s*(.*)$/.exec(title);
    var text = m ? m[2] : title;
    var glyph = m ? m[1] : iconFor(text);
    var icon = glyph ? '<span class="la-specacc__ic" aria-hidden="true">' + esc(glyph) + '\ufe0f</span>' : '';
    return icon + '<span>' + esc(text) + '</span><span class="la-specacc__chev" aria-hidden="true"></span>';
  }

  function foldTable(table) {
    var rows = Array.prototype.slice.call(table.rows);
    var groups = [], cur = null;
    rows.forEach(function (tr) {
      if (isGroupRow(tr)) { cur = { title: tr.cells[0].textContent.trim(), rows: [] }; groups.push(cur); }
      else if (cur) cur.rows.push(tr);
    });
    if (groups.length < 2) return;

    var wrap = document.createElement('div');
    wrap.className = 'la-specacc';
    groups.forEach(function (g) {
      var d = document.createElement('details');   /* all start collapsed */
      d.className = 'la-specacc__grp';
      var s = document.createElement('summary');
      s.innerHTML = summaryHTML(g.title);
      d.appendChild(s);
      var t = document.createElement('table');
      t.className = 'la-specacc__tbl';
      var tb = document.createElement('tbody');
      g.rows.forEach(function (r) { tb.appendChild(r); });   /* moves the original rows, styles intact */
      t.appendChild(tb);
      d.appendChild(t);
      wrap.appendChild(d);
    });
    table.parentNode.replaceChild(wrap, table);
  }

  function foldSpecTables() {
    document.querySelectorAll('.product-description table, .rte table').forEach(function (t) {
      if (t.closest('.la-specacc')) return;
      var ths = 0;
      Array.prototype.forEach.call(t.rows, function (tr) { if (isGroupRow(tr)) ths++; });
      if (ths >= 2) foldTable(t);
    });
  }

  /* Tigren renders its block after its own script runs; poll for up to ~12s. */
  function foldAttachments() {
    var tries = 0;
    (function poll() {
      var blk = document.querySelector('.tigren-product-attachments');
      /* Each attachment card carries more than one <a> (icon + title), so count
         distinct link targets rather than anchor tags. */
      var links = 0;
      if (blk) {
        var seen = {};
        blk.querySelectorAll('a').forEach(function (a) { var h = a.getAttribute('href'); if (h && !seen[h]) { seen[h] = 1; links++; } });
      }
      if (blk && links && !blk.closest('.la-specacc__attwrap')) {
        var d = document.createElement('details');
        d.className = 'la-specacc__grp la-specacc__attwrap';
        var s = document.createElement('summary');
        s.innerHTML = '<span>Product Attachments <em class="la-specacc__n">(' + links +
          (links === 1 ? ' PDF' : ' PDFs') + ')</em></span><span class="la-specacc__chev" aria-hidden="true"></span>';
        blk.parentNode.insertBefore(d, blk);
        d.appendChild(s);
        d.appendChild(blk);   /* the app's own big heading is hidden by CSS */
        placeAttachments(d);
        alignColumns();       /* both columns' heights just changed */
        return;
      }
      if (++tries < 40) setTimeout(poll, 300);
    }());
  }

  /* Clamp the marketing prose behind "Read full description".

     Three shapes, because the spec table sits in a different place per family:
       - ovens: prose continues AFTER the table, so that trailing prose clamps;
       - spray booths: the table is the LAST thing in the description, so there
         is nothing after it — clamp the prose ABOVE it instead;
       - products with no table at all: clamp the whole description.
     Without the middle case, adding a spec table to a booth silently removed its
     Read-more button, because the "everything after the table" span was empty. */
  function clampProse() {
    var acc = document.querySelector('.la-specacc');
    var desc = document.querySelector('.product-description');
    if (!desc || document.querySelector('.la-readmore')) return;

    /* Static list of nodes from `first` up to but not including `stop`. */
    function span(first, stop) {
      var out = [], n = first;
      while (n && n !== stop) { out.push(n); n = n.nextSibling; }
      return out;
    }
    /* How much markup a list carries, descendants included. Measured BEFORE
       anything moves: the old check built the wrap first and returned early when
       it came up short, stranding whatever it had already swallowed. */
    function bulk(nodes) {
      var n = 0;
      nodes.forEach(function (x) {
        if (x.nodeType === 1) n += 1 + x.getElementsByTagName('*').length;
      });
      return n;
    }
    function chars(nodes) {
      var n = 0;
      nodes.forEach(function (x) {
        n += ((x.textContent || '').replace(/\s+/g, ' ').trim()).length;
      });
      return n;
    }
    /* Too little to be the description body. Element count alone was too brittle:
       the oversized-freight warning is one <p>, but wrapping it <p><em><strong>
       counts three elements and slipped past a bare `bulk < 3` test, so the
       script clamped the WARNING instead of the prose and never drew a button.
       Real description prose runs thousands of characters; that notice is ~150. */
    function thin(nodes) { return bulk(nodes) < 3 || chars(nodes) < 400; }

    var parent, nodes, above = false;
    if (acc && acc.parentNode) {
      parent = acc.parentNode;
      nodes = span(acc.nextSibling, null);
      if (thin(nodes)) { nodes = span(parent.firstChild, acc); above = true; }
    } else {
      parent = desc;
      /* Descend past a lone wrapper div, but never into a single block. */
      while (parent.children.length === 1 && parent.firstElementChild.children.length > 1) {
        parent = parent.firstElementChild;
      }
      nodes = span(parent.firstChild, null);
    }
    if (thin(nodes)) return;

    var wrap = document.createElement('div');
    wrap.className = 'la-readmore';
    if (above) parent.insertBefore(wrap, acc); else parent.appendChild(wrap);
    nodes.forEach(function (n) { wrap.appendChild(n); });
    if (wrap.scrollHeight < 480) return;
    wrap.classList.add('is-clamped');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'la-readmore__btn';
    btn.textContent = 'Read full description';
    btn.setAttribute('aria-expanded', 'false');
    btn.addEventListener('click', function () {
      var open = wrap.classList.toggle('is-open');
      wrap.classList.toggle('is-clamped', !open);
      btn.textContent = open ? 'Show less' : 'Read full description';
      btn.setAttribute('aria-expanded', String(open));
      if (!open) wrap.scrollIntoView({ block: 'start', behavior: 'smooth' });
      queueAlign();
    });
    if (above) parent.insertBefore(btn, wrap.nextSibling); else parent.appendChild(btn);
  }

  /* ---- the intro region -------------------------------------------------
     Everything in the description that sits ABOVE the folded spec table.
     Product HTML varies by family: some products wrap their blocks in a plain
     container, some list them flat; some lead with the coating chips, some with
     the spec intro. So work from the shared design-system classes (.lao-cards,
     .lao-stats, .lao-eyebrow, .lao-h) rather than from any one product's
     wording, with the wording kept only as a fallback. */
  function txt(el) { return ((el && el.textContent) || '').replace(/\s+/g, ' ').trim(); }

  function introBlocks() {
    var acc = document.querySelector('.la-specacc');
    var desc = document.querySelector('.product-description');
    if (!acc || !desc || !desc.contains(acc) || !acc.parentNode) return null;
    /* Product HTML nests inconsistently: some descriptions list every block flat,
       some wrap the lot in one container, and some split it into two or more
       containers with the chips in the FIRST and the spec table in a later one.
       So collect everything that precedes the accordion at EVERY level between it
       and .product-description, outermost level first, which is document order. */
    var rm = document.querySelector('.la-readmore');
    var levels = [], node = acc, depth = 0;
    while (node && node !== desc && node.parentNode && depth++ < 8) {
      var sibs = [], n = node.parentNode.firstElementChild, guard = 0;
      while (n && n !== node && guard++ < 20) {
        /* Skip the clamp wrapper (and anything holding it): when the table is last
           in the description the prose above it is already inside the clamp, so
           there is nothing left to strip or fold. */
        if (!(rm && (n === rm || n.contains(rm)))) sibs.push(n);
        n = n.nextElementSibling;
      }
      levels.unshift(sibs);
      node = node.parentNode;
    }
    var list = [];
    levels.forEach(function (s) { list = list.concat(s); });
    return { acc: acc, list: list };
  }

  function has(el, cls) {
    return !!(el && ((el.classList && el.classList.contains(cls)) ||
      (el.querySelector && el.querySelector('.' + cls))));
  }

  /* The three highlight tiles ("Max Temperature / Inside Working Space / Weight")
     — the same facts the table already carries, in a bigger box. */
  function isTiles(el) {
    if (has(el, 'lao-stats')) return true;
    var t = txt(el);
    return /max temperature/i.test(t) && /weight/i.test(t);
  }

  /* A short eyebrow/heading line, e.g. "TECHNICAL SPECIFICATIONS" +
     "Everything You Need To Know" — only ever dropped when it sits directly
     above the tiles it introduces. */
  function isIntroHeading(el) {
    if (!el || !el.parentNode) return false;
    var t = txt(el);
    if (t.length > 80) return false;
    if (has(el, 'lao-eyebrow') || has(el, 'lao-h')) return true;
    return /everything you need to know|technical specifications/i.test(t);
  }

  /* The coating chips block: its eyebrow/heading lines AND the card grid itself.
     On some products the grid div carries no class at all, so recognize it by
     the coating names it lists — matching the heading lines alone would leave
     the grid behind, unfolded. */
  function isChips(el) {
    if (has(el, 'lao-cards')) return true;
    var t = txt(el);
    if (/trusted for every finish|approved applications/i.test(t)) return true;
    return /powder coating/i.test(t) && /cerakote/i.test(t) && t.length < 400;
  }

  /* Remove the redundant spec intro, harvesting any tile fact the table lacks. */
  function removeSpecIntro() {
    var ctx = introBlocks();
    if (!ctx) return;
    var acc = ctx.acc;
    var accText = acc.textContent.toLowerCase();

    function appendRow(label, value) {
      var groups = acc.querySelectorAll('.la-specacc__grp');
      var target = null;
      for (var i = 0; i < groups.length; i++) {
        var head = groups[i].querySelector('summary').textContent.toLowerCase();
        if (/weight|shipping/.test(label.toLowerCase()) && /shipping|dimension/.test(head)) { target = groups[i]; break; }
        if (/temperature/.test(label.toLowerCase()) && /performance|control/.test(head)) { target = groups[i]; break; }
      }
      if (!target) target = groups[0];
      if (!target) return;
      var body = target.querySelector('tbody');
      var last = body && body.rows.length ? body.rows[body.rows.length - 1] : null;
      if (!last || last.cells.length < 2) return;
      var row = last.cloneNode(true);
      row.cells[0].textContent = label;
      row.cells[1].textContent = value;
      body.appendChild(row);
    }

    var list = ctx.list;
    for (var i = 0; i < list.length; i++) {
      if (!isTiles(list[i])) continue;
      list[i].querySelectorAll('*').forEach(function (el) {
        var lt = txt(el);
        /* 'Inside Working Space' duplicates the table's 'Inside Working
           Dimensions' in another format — never harvest it. */
        if (/^(max(imum)? temp(erature)?|(shipping )?weight)$/i.test(lt)) {
          var val = el.nextElementSibling ? txt(el.nextElementSibling) : '';
          if (val && accText.indexOf(val.toLowerCase()) === -1 && accText.indexOf(lt.toLowerCase()) === -1) {
            appendRow(lt.replace(/\b\w/g, function (c) { return c.toUpperCase(); }), val);
          }
        }
      });
      /* Take the eyebrow/heading pair that introduces the tiles with them. */
      var j = i - 1, drops = 0;
      while (j >= 0 && drops < 2 && list[j] && list[j].parentNode === list[i].parentNode &&
             isIntroHeading(list[j])) {
        list[j].remove();
        list[j] = null;
        j--; drops++;
      }
      list[i].remove();
      list[i] = null;
    }
  }

  /* Fold the coating chips into the Read-more clamp — appended at the END so the
     clamped teaser still opens with the product pitch, and the chips show only on
     expand. The chips carry their own lead-in line on some products and an
     eyebrow/heading pair on others, so everything from the top of the description
     down to the chips moves as one piece. A product with no chips is left alone. */
  function foldChips() {
    var wrap = document.querySelector('.la-readmore');
    if (!wrap) return;
    var ctx = introBlocks();
    /* With a spec table the chips sit above it and move INTO the clamp; with no
       table the whole description is already inside the clamp, so the chips just
       move to its END — either way the teaser opens on the product pitch. */
    function lastChips(l) {
      var idx = -1;
      for (var i = 0; i < l.length; i++) { if (l[i] && l[i].parentNode && isChips(l[i])) idx = i; }
      return idx;
    }
    var list = ctx ? ctx.list : Array.prototype.slice.call(wrap.children);
    list = list.filter(function (el) { return el && el.parentNode; });
    var last = lastChips(list);
    if (last === -1) {
      /* Booths: the clamp wraps the prose ABOVE the table, so the chips live
         INSIDE it (at the top) and the sibling scan can't see them. Rescan the
         clamp's own children; moving 0..chips to the end leaves the pitch first,
         matching the ovens. */
      list = Array.prototype.slice.call(wrap.children);
      last = lastChips(list);
    }
    if (last === -1) return;
    for (var k = 0; k <= last; k++) wrap.appendChild(list[k]);
  }

  /* Small eyebrow label above the accordion, matching the theme's style. */
  function addSpecLabel() {
    var acc = document.querySelector('.la-specacc');
    if (!acc || !acc.parentNode || document.querySelector('.la-specacc__head')) return;
    var head = document.createElement('div');
    head.className = 'la-specacc__head';
    head.textContent = 'Technical Specifications';
    acc.parentNode.insertBefore(head, acc);
  }

  /* The Tigren block renders inside the buy column. Move its fold into the
     description, at the tail of the spec accordion, so the left column reads
     description → specs → attachments. Appended INSIDE .la-specacc so the
     divider lines run continuously; CSS gives it a small gap above. */
  function placeAttachments(d) {
    var acc = document.querySelector('.la-specacc');
    if (acc) {
      if (!acc.contains(d)) acc.appendChild(d);
      return;
    }
    /* No spec table on this product: park the fold at the foot of the
       description, under the Read-more button, rather than leaving it in the
       buy column. */
    var btn = document.querySelector('.la-readmore__btn');
    var wrap = document.querySelector('.la-readmore');
    var host = btn ? btn.parentNode : (wrap ? wrap.parentNode : null);
    if (host && !host.contains(d)) host.appendChild(d);
  }

  /* Specs read as reference material, not as the pitch — so they belong after the
     description rather than ahead of it. Runs last, once clampProse/foldChips have
     finished using the original order: head and accordion move to the end of the
     block, landing below the "Read full description" button. */
  function reorderSpecs() {
    var acc = document.querySelector('.la-specacc');
    var head = document.querySelector('.la-specacc__head');
    var btn = document.querySelector('.la-readmore__btn');
    if (!acc || !head || !btn || btn.parentNode !== acc.parentNode) return;
    var parent = acc.parentNode;
    parent.appendChild(head);
    parent.appendChild(acc);
  }

  /* The review slider (.la-rev) is the buy column's tail. Two earlier revs nudged it
     down to line the two columns up — first against the description's foot, then
     against the "Read full description" button. Both traded a gap at the bottom of
     the shorter column for a hole in the MIDDLE of the buy column, directly under
     the Feedback Promo line, which is far more noticeable: measured 71px on the
     LA225, 150px on the LABS-586. So no nudge at all now — the slider sits where
     the column puts it, ~14px under the promo line. This only clears any inline
     margin a cached older copy of this script may have left behind; the plumbing
     (resize, expand/collapse, attachments-fold) stays wired so the behaviour is in
     one place if it ever needs to come back. */
  function alignColumns() {
    var rev = document.querySelector('.la-rev');
    if (rev && rev.style.marginTop) rev.style.marginTop = '';
  }
  var alignT = null;
  function queueAlign() { clearTimeout(alignT); alignT = setTimeout(alignColumns, 150); }

  function init() {
    foldSpecTables();
    clampProse();
    removeSpecIntro();
    foldChips();
    addSpecLabel();
    reorderSpecs();
    /* Last: the app's block arrives asynchronously, and by now it has a settled
       destination to land in. */
    foldAttachments();
    alignColumns();
    /* Late passes: images/fonts/apps shift heights after load. */
    setTimeout(alignColumns, 1200);
    setTimeout(alignColumns, 3000);
    window.addEventListener('resize', queueAlign);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
}());

/* Light Armor — hover magnifier + click-to-open lightbox together (added 2026-08-30).
 *
 * The Enterprise theme treats the two as either/or. Its "Image zoom" setting is a
 * single choice: 'hover' renders the magnifier but omits the <gallery-zoom-open>
 * wrapper and the lightbox template entirely, so an image can be magnified but
 * never opened; 'lightbox' renders the full-screen viewer but emits no
 * data-zoom-trigger, so media-gallery.js never wires the magnifier — and even if
 * something called it, handleZoomMouseMove() bails on its own
 * `!this.dataset.zoomTrigger` guard.
 *
 * So the section setting stays on 'lightbox' (the half that needs Liquid), and
 * this restores the other half at runtime: set the attribute the guard looks for,
 * then call the gallery's own triggerZoomInit(). Nothing is re-implemented — the
 * magnifier is the theme's, the lightbox is the theme's, and the click still
 * bubbles from the zoom link up to <gallery-zoom-open> because triggerZoomInit
 * only calls preventDefault (it never stops propagation).
 *
 * The gallery is a custom element that sets up zoomLinks in its constructor, and
 * media-gallery.js is deferred, so poll briefly rather than assuming it upgraded.
 */
(function () {
  'use strict';
  if (window.__laHoverZoom) return;
  window.__laHoverZoom = true;

  function arm() {
    var done = false;
    document.querySelectorAll('media-gallery[data-zoom-enabled]').forEach(function (g) {
      /* Not upgraded yet, or nothing zoomable on this product. */
      if (!g.zoomLinks || !g.zoomLinks.length) return;
      done = true;
      if (g.dataset.zoomTrigger) return;          /* already hover/click mode */
      if (typeof g.triggerZoomInit !== 'function') return;
      g.dataset.zoomTrigger = 'hover';
      try {
        g.triggerZoomInit();
      } catch (e) {
        /* Leave the theme exactly as it was rather than half-wired. */
        delete g.dataset.zoomTrigger;
      }
    });
    return done;
  }

  var tries = 0;
  (function poll() {
    if (arm()) return;
    if (++tries < 40) setTimeout(poll, 150);   /* ~6s */
  }());
}());
